import React, { useEffect } from 'react';
import { useHelp } from './TourContext';
import { getTourSteps } from './tourSteps';
import HoverTooltip from './HoverTooltip';

const HelpSystem = ({ pageName }) => {
  const { isHelpModeActive } = useHelp();
  
  // Show tooltips if help mode is active
  const isActive = isHelpModeActive;
  
  if (!isActive) return null;

  const steps = getTourSteps(pageName);
  
  return (
    <>
      {steps.map((step, index) => (
        <HoverTooltip
          key={index}
          target={step.target}
          title={step.title}
          content={step.content}
          label={step.label}
          labelText={step.labelText}
          tip={step.tip}
          additionalInfo={step.additionalInfo}
          isActive={isActive}
        />
      ))}
    </>
  );
};

export default HelpSystem;
